import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f0f0f0;
  border-radius: 24px;
`;
